import { render, staticRenderFns } from "./NoDataAlert.vue?vue&type=template&id=3df33fe8"
import script from "./NoDataAlert.vue?vue&type=script&lang=js"
export * from "./NoDataAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports